import { render, staticRenderFns } from "./PainelDoChatDeSuporte.vue?vue&type=template&id=174e9d72&scoped=true&"
import script from "./PainelDoChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./PainelDoChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./PainelDoChatDeSuporte.vue?vue&type=style&index=0&id=174e9d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e9d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
